/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LocationListAdmin } from './LocationListAdmin'
import {
  LocationListAdminFromJSON,
  LocationListAdminFromJSONTyped,
  LocationListAdminToJSON,
} from './LocationListAdmin'

/**
 *
 * @export
 * @interface PaginatedLocationListAdmin
 */
export interface PaginatedLocationListAdmin {
  /**
   *
   * @type {Array<LocationListAdmin>}
   * @memberof PaginatedLocationListAdmin
   */
  results: Array<LocationListAdmin>
  /**
   *
   * @type {number}
   * @memberof PaginatedLocationListAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedLocationListAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedLocationListAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedLocationListAdmin interface.
 */
export function instanceOfPaginatedLocationListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedLocationListAdminFromJSON(json: any): PaginatedLocationListAdmin {
  return PaginatedLocationListAdminFromJSONTyped(json, false)
}

export function PaginatedLocationListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedLocationListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(LocationListAdminFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedLocationListAdminToJSON(value?: PaginatedLocationListAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(LocationListAdminToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
